import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FacadeService } from 'src/app/services/FacadeService';
import { LoginRequest, RegistrationRequest, User } from 'src/models';
import { login, logout } from '../../store/user/user.action';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.less']
})
export class ResetPasswordDialogComponent implements OnInit {
  data: RegistrationRequest;
  showSpinner: boolean;
  lowerCaseLetters: RegExp;
  upperCaseLetters: RegExp;
  numbers: RegExp;
  specialCharacters: RegExp;
  validEmailAddress: RegExp;
  showError: boolean;
  errorMessage: string;
  user$: Observable<User>;
  user: User;
  
  constructor(private service: FacadeService, public dialogRef: MatDialogRef<ResetPasswordDialogComponent>, private store: Store<{user: User}>  ) { }

  ngOnInit(): void {
    this.data = new RegistrationRequest();
    this.errorMessage = '';
    this.lowerCaseLetters = /[a-z]/g;
    this.upperCaseLetters = /[A-Z]/g;
    this.numbers = /[0-9]/g;
    this.specialCharacters = /[!@#$%^&*(),.?":{}|<>]/g;
    this.validEmailAddress= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
  
    this.user = new User();
    this.user$ = this.store.select('user');
    this.user$.subscribe(x => {
      this.user = x;      
    });    
  }

  onSave() { 
    const d = this.data;
    if(!this.hasValidPassword || !(d.password == d.confirmPassword)){
      this.showError = true;
      return;
    }

    this.showError = false;
    this.showSpinner = true;

    const loginRequest = new LoginRequest();
    loginRequest.userName = this.user.emailAddress;
    loginRequest.password = d.password;

    this.service.productService.SavePassword(loginRequest).then(data => {         
      const d = data as any; 
      if(d.success) {        
        const u = {...d.user, isLoggedIn: true, resetPassword: false};
        this.store.dispatch(login({user: u}));
        this.dialogRef.close();
      } else {
        this.errorMessage = d.errorMessage;
        this.showSpinner = false;
      }
   })
  }

  onLogout() {
    this.service.productService.Logout().then(() => {
      this.store.dispatch(logout());
      this.dialogRef.close();
    });    
  }

  get hasLowerCaseLetters() {
    return this.data.password.match(this.lowerCaseLetters);
  }

  get hasUpperCaseLetters() {
    return this.data.password.match(this.upperCaseLetters);
  }

  get hasNumber() {
    return this.data.password.match(this.numbers);
  }

  get hasSpecialCharacter() {
    return this.data.password.match(this.specialCharacters);
  }

  get hasMinimumCharacters() {
    return this.data.password.length >= 8;
  }

  get hasValidEmailAddress() {
    return this.data.emailAddress.match(this.validEmailAddress);
  }

  get hasValidPassword() {
    return this.hasUpperCaseLetters &&
       this.hasLowerCaseLetters && 
       this.hasNumber && 
       this.hasSpecialCharacter && 
       this.hasMinimumCharacters 
  }
}
